import _ from 'underscore'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import $appConfig from 'servicestack/config'
import templateUrl from 'emun.salesrep/subrep-dashboard.htm'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import salesrepConfig from 'emun.salesrep/salesrep.config'
import ServiceBus from 'servicestack/service-bus'

class SubRepDashboardController  {
    constructor(createAutoQuery, $session, $window, $state) {
        basicController(this)
        var map = this;
        let $ctrl = this;
        $ctrl.bus = new ServiceBus();
        $ctrl.salesrepConfig = salesrepConfig;
        $ctrl.chartLoaded = false;
        $ctrl.productImage = $appConfig.productImage;
        let options = {
            url: 'QuerySalesReps.json?IncludeSalesData=true&Id=' + $ctrl.repId,
            pageSize: 15,
            orderBy: 'Name',
            autoLoad: true,
            append: false,
            onLoaded: function(args) {
                $ctrl.rep = args.first;
                $ctrl.$state.current.customTitle = $ctrl.rep.name;
            }
        };
		$ctrl.goals = {
			month: 0,
			monthPercent: 0,
			quarter: 0,
			quarterPercent: 0,
			year: 0,
			yearPercent: 0
		};
        $ctrl.dailySales = {
            total: 0,
            count: 0
        };
        $ctrl.yesterdaySales = {
            total: 0,
            count: 0
        };
        $ctrl.weekSales = {
            total: 0,
            count: 0
        };
        $ctrl.lastweekSales = {
            total: 0,
            count: 0
        };
        $ctrl.quarterSales = {
            total: 0,
            count: 0,
			percent: 0,
			trend: 'neutral'
        };
        $ctrl.lastquarterSales = {
            total: 0,
            count: 0
        };
        $ctrl.ytdSales = {
            total: 0,
            count: 0,
            percent: 0,
			trend: 'neutral'
        };
        $ctrl.lastytdSales = {
            total: 0,
            count: 0
        };
		$ctrl.mtdSales = {
			total: 0,
			count: 0,
			percent: 0,
			trend: 'neutral'
		};
		$ctrl.lastmtdSales = {
			total: 0,
			count: 0
		};
        $ctrl.query = createAutoQuery(options);

		$ctrl.todaySalesQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?Sum=SalesDailyTotal,SalesDailyCount&DateRange=Today&SubRepId=' + $ctrl.repId,
            autoLoad: true,
            pageSize: 1000,
			onLoaded: function(args) {
				if (args.total > 0) {
					$ctrl.dailySales.total = args.first.orderTotal;
					$ctrl.dailySales.count = args.first.orderCount;
				}
			}
		});
		$ctrl.todaySalesQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?Sum=SalesDailyTotal,SalesDailyCount&DateRange=Yesterday&SubRepId=' + $ctrl.repId,
            autoLoad: true,
            pageSize: 1000,
			onLoaded: function(args) {
				if (args.total > 0) {
					$ctrl.yesterdaySales.total = args.first.orderTotal;
					$ctrl.yesterdaySales.count = args.first.orderCount;
				}
			}
		});
		$ctrl.weekSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?Sum=SalesDailyTotal,SalesDailyCount&DateRange=Week&SubRepId=' + $ctrl.repId,
            autoLoad: true,
            pageSize: 1000,
			onLoaded: function(args) {
				if (args.total > 0) {
					$ctrl.weekSales.total = args.first.orderTotal;
					$ctrl.weekSales.count = args.first.orderCount;
				}
			}
		});
		$ctrl.lastweekSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?Sum=SalesDailyTotal,SalesDailyCount&DateRange=LastWeek&SubRepId=' + $ctrl.repId,
            autoLoad: true,
            pageSize: 1000,
			onLoaded: function(args) {
				if (args.total > 0) {
					$ctrl.lastweekSales.total = args.first.orderTotal;
					$ctrl.lastweekSales.count = args.first.orderCount;
				}
			}
		});
		$ctrl.quarterSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?Sum=SalesDailyTotal,SalesDailyCount&DateRange=Quarter&SubRepId=' + $ctrl.repId,
            autoLoad: true,
            pageSize: 1000,
			onLoaded: function(args) {
				if (args.total > 0) {
					$ctrl.quarterSales.total = args.first.orderTotal;
					$ctrl.quarterSales.count = args.first.orderCount;
				}
			}
		});
		$ctrl.lastquarterSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?Sum=SalesDailyTotal,SalesDailyCount&DateRange=LastQuarter&SubRepId=' + $ctrl.repId,
            autoLoad: true,
            pageSize: 1000,
			onLoaded: function(args) {
				if (args.total > 0) {
					$ctrl.lastquarterSales.total = args.first.orderTotal;
					$ctrl.lastquarterSales.count = args.first.orderCount;
					var percent = Math.round(($ctrl.quarterSales.total / $ctrl.lastquarterSales.total) * 100);
					if ($ctrl.lastquarterSales.total == 0) { percent = 100; }
					if (percent < 100) {
						$ctrl.quarterSales.percent = 100 - percent;
						$ctrl.quarterSales.trend = 'down';
					} else if (percent > 100) {
						$ctrl.quarterSales.percent = percent - 100;
						$ctrl.quarterSales.trend = 'up';
					} else {
						$ctrl.quarterSales.percent = 100;
						$ctrl.quarterSales.trend = 'neutral';
					}
				}
			}
		});
		$ctrl.ytdSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?Sum=SalesDailyTotal,SalesDailyCount&DateRange=YTD&SubRepId=' + $ctrl.repId,
            autoLoad: true,
            pageSize: 1000,
			onLoaded: function(args) {
				if (args.total > 0) {
					$ctrl.ytdSales.total = args.first.orderTotal;
					$ctrl.ytdSales.count = args.first.orderCount;
				}
			}
		});
		$ctrl.lytdSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?Sum=SalesDailyTotal,SalesDailyCount&DateRange=LYTD&SubRepId=' + $ctrl.repId,
            autoLoad: true,
            pageSize: 1000,
			onLoaded: function(args) {
				if (args.total > 0) {
					$ctrl.lastytdSales.total = args.first.orderTotal;
					$ctrl.lastytdSales.count = args.first.orderCount;
					var percent = Math.round(($ctrl.ytdSales.total / $ctrl.lastytdSales.total) * 100);
					if ($ctrl.lastytdSales.total == 0) { percent = 100; }
					if (percent < 100) {
						$ctrl.ytdSales.percent = 100 - percent;
						$ctrl.ytdSales.trend = 'down';
					} else if (percent > 100) {
						$ctrl.ytdSales.percent = percent - 100;
						$ctrl.ytdSales.trend = 'up';
					} else {
						$ctrl.ytdSales.percent = 100;
						$ctrl.ytdSales.trend = 'neutral';
					}
				}
			}
		});
		$ctrl.mtdSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?Sum=SalesDailyTotal,SalesDailyCount&DateRange=MTD&SubRepId=' + $ctrl.repId,
            autoLoad: true,
            pageSize: 1000,
			onLoaded: function(args) {
				if (args.total > 0) {
					$ctrl.mtdSales.total = args.first.orderTotal;
					$ctrl.mtdSales.count = args.first.orderCount;
				}
			}
		});
		$ctrl.lmtdSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?Sum=SalesDailyTotal,SalesDailyCount&DateRange=LYMTD&SubRepId=' + $ctrl.repId,
            autoLoad: true,
            pageSize: 1000,
			onLoaded: function(args) {
				if (args.total > 0) {
					$ctrl.lastmtdSales.total = args.first.orderTotal;
					$ctrl.lastmtdSales.count = args.first.orderCount;
					var percent = Math.round(($ctrl.mtdSales.total / $ctrl.lastmtdSales.total) * 100);
					if ($ctrl.lastmtdSales.total == 0) { percent = 100; }
					if (percent < 100) {
						$ctrl.mtdSales.percent = 100 - percent;
						$ctrl.mtdSales.trend = 'down';
					} else if (percent > 100) {
						$ctrl.mtdSales.percent = percent - 100;
						$ctrl.mtdSales.trend = 'up';
					} else {
						$ctrl.mtdSales.percent = 100;
						$ctrl.mtdSales.trend = 'neutral';
					}
				}
			}
		});
        $ctrl.openOrders = createAutoQuery({
            url: 'QueryCarts.json?StatusNotEqualTo=Cart&salesrepid=' + $ctrl.repId,
            orderBy: '-OrderedOn',
            autoLoad: true,
            pageSize: 10
        });
        $ctrl.$session = $session;
		$ctrl.markets = [];
		$ctrl.showCodesQuery = createAutoQuery({
			url: 'QueryMarketDates.json',
			take: 1000,
			autoLoad: true,
			onLoaded: function (args) {
				args.results.forEach(function (market) {
					if ($ctrl.markets.filter(m => m.market == market.market && m.year == market.year).length == 0) {
						$ctrl.markets.push(market);
					}
				});
			}
		});
    }
	$onInit() {
		const $ctrl = this;
/*
		setTimeout(function () {
			window.scrollTo(0,0);
		}, 3000);
*/
	}
    load(){return $ctrl.query.load.apply($ctrl.query, arguments);}
    runReport(name){
        const $ctrl = this;
        let url = "/service/" + name + "?salesrepid=" + $ctrl.repId; 
        return location.href = url;
    }
}

let SubRepDashboard = {
    bindings: {
        repId: '@'
    },
    require:{
        container: '^salesrepContainer'
    },
    controller: SubRepDashboardController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default SubRepDashboard